import { useCallback, useState } from 'react';

/**
 * useDialogState provides a convenient way to manage the open/close state of a
 * dialog
 * @param matchers
 */
export default function useDialogState(initialOpen: boolean) {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return [isOpen, open, close] as const;
}
